<template>
  <div class="drawer-detail">
    <div v-for="field in fields" :key="field" class="field-type">
      <span class="label">{{translateTag[field]||field}}:</span>
      <SearchTagInputShow v-if="tagFields.includes(field)" :value="company[field]" :translate="field==='业务特点/风格/资源来源'?translate:{}" @quickEdit="quickEdit(field)"></SearchTagInputShow>
      <div v-else :class="[company[field]?'':'gray-text','value company-pre']">
        <p v-if="company[field]">{{company[field]}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit(field)"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
  </div>
</template>
<script>
import SearchTagInputShow from './SearchTagInputShow'

export default {
  components: { SearchTagInputShow },
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['一句话简介', '公司亮点','公司劣势', '优势业务', '业务特点/风格/资源来源', '人员风格'],
      tagFields:['公司亮点','公司劣势','业务特点/风格/资源来源'],
      translateTag: {
        一句话简介: '一句话介绍',
        公司亮点: '公司亮点',
        '业务特点/风格/资源来源': '业务特点',
      },
      translate: {
        A: 'A-极度市场化',
        B: 'B-较市场化',
        C: 'C-大平台、合理激励',
        D: 'D-偏向国企风格，较保守',
        E: 'E-大国企、保守',
        F: '团队作战，精英模式',
      },
    }
  },
  computed: {
    hasCognize() {
      const fields = ['人员受认可度', '固定薪酬', '激励机制', '人员稳定性']
      let flag = false
      for(const field of fields){
        if(this.company[field]) flag = true
      }
      return flag
    },
    cognizeFields(){
      const fields = ['人员受认可度', '固定薪酬', '激励机制', '人员稳定性']
      const arr = fields.filter(v=>this.company[v])
      return arr
    },
  },
  methods: {
    quickEdit(field){
      const { translateTag, company, tagFields } = this
      this.$emit('quickEdit',{
        value: company[field],
        label:translateTag[field]||field,
        type:tagFields.includes(field)?'tagInput':'input',
        confirmFunc:async(v)=>{
          const res = await app.service('company').modifyCompany({
            query: { _id: this.company._id },
            data: { [field]: v },
          })
          if (res.status === 'success' || res.status === 200) {
            this.$set(this.company,field,v)
            this.$message.success(`修改成功`)
          }
        },
      })
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.cognize-box{
  display: flex;
  flex-wrap:wrap;
}
.cognize-box span{
  display: inline-block;
  min-width: 50%;
  padding: 0 10px 10px;
  box-sizing: border-box;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
